import { PricingEditsStore } from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store-types';
import { useIsFocused } from '@react-navigation/native';
import { useLayoutEffect, useRef } from 'react';
import { usePricingEditsStore } from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store';

/**
 * `usePricingEditsStore` for screens that stay mounted under the stack. While
 * the screen is blurred the selector keeps returning its last focused result,
 * so an edit made on the screen above doesn't re-render this one; it catches
 * up on the render that refocuses it.
 */
export const useFocusedPricingEditsStore = <T>(
  selector: (state: PricingEditsStore) => T,
): T => {
  const isFocused = useIsFocused();
  const lastRef = useRef<{ value: T } | null>(null);

  const value = usePricingEditsStore((state) =>
    isFocused || lastRef.current === null
      ? selector(state)
      : lastRef.current.value,
  );

  useLayoutEffect(() => {
    lastRef.current = { value };
  });

  return value;
};
